const totalPopulationKey = (selectedGeoBoundary) => {
  const populationMap = {
    county: 'countyPopulation',
    congressionaldistrict: 'congressionalDistrictPopulation',
    censustract: 'censusTractPopulation',
    state: 'statePopulation'
  }
  return populationMap[selectedGeoBoundary]
}
export const setSortColumns = (selectedGeoBoundary, columnData, columns, isFilterApplied, getSortedData) => {
  let flag = false
  let condition = false
  if (
    (selectedGeoBoundary === 'county' &&
      columnData?.orderBy !== 'state' &&
      columnData?.orderBy === 'congressional_district') ||
    (selectedGeoBoundary === 'congressionaldistrict' &&
      columnData?.orderBy !== 'state' &&
      columnData?.orderBy === 'county') ||
    (selectedGeoBoundary === 'state' &&
      (columnData?.orderBy === 'congressional_district' || columnData?.orderBy === 'county'))
  )
    condition = true

  if (condition) {
    if (selectedGeoBoundary === 'congressionaldistrict') {
      selectedGeoBoundary = 'congressional_district'
    }
    columnData = {orderBy: selectedGeoBoundary, order: columnData?.order}
  }

  const defaultPopulationKey = isFilterApplied ? 'population' : totalPopulationKey(selectedGeoBoundary)
  // checking if the columnData.orderBy is present in columns else moving to default column
  flag = columns.some((e) => e.dataKey === columnData?.orderBy)
  if (flag) getSortedData(columnData?.order, columnData?.orderBy)
  else if (columns.some((e) => e.dataKey === 'snapEnrolled'))
    getSortedData(columnData?.order, 'snapEnrolled', columnData?.orderBy)
  else if (columns.some((e) => e.dataKey === 'usdaSnapIndNotEnrolled'))
    getSortedData(columnData?.order, 'usdaSnapIndNotEnrolled', columnData?.orderBy)
  else getSortedData(columnData?.order, defaultPopulationKey) // default case
}

export const getIncomeValue = (incomeStr) => {
  if (incomeStr.startsWith('Less than')) return 0
  if (incomeStr.includes('+')) return Number.MAX_SAFE_INTEGER
  const match = incomeStr.match(/\$([0-9,]+)/)
  return match ? Number.parseInt(match[1].replaceAll(',', ''), 10) : 0
}
const getPercentageValueForSort = (percentageStr) => {
  if (typeof percentageStr !== 'string') return Number.parseFloat(percentageStr) || 0

  // Handle strings with '<' prefix (e.g., '<1')
  if (percentageStr.startsWith('<')) {
    const numValue = Number.parseFloat(percentageStr.substring(1))
    return numValue - 0.1
  }

  // Handle strings with '>' prefix (e.g., '>99')
  if (percentageStr.startsWith('>')) {
    const numValue = Number.parseFloat(percentageStr.substring(1))
    // Return a slightly larger value to ensure '>99' comes after '99'
    return numValue + 0.1
  }

  // Handle regular percentage strings
  return Number.parseFloat(percentageStr) || 0
}

export const sortDataForSpecialColumns = (order, orderBy, label, type, data) => {
  if (label === 'Income Level') {
    data.sort((a, b) => {
      const valueA = getIncomeValue(a.binName)
      const valueB = getIncomeValue(b.binName)
      if (order === 'asc') {
        return valueA - valueB
      } else {
        return valueB - valueA
      }
    })
  } else if (orderBy === 'congressional_district') {
    const ordinalToNumber = (value) => {
      if (value === 'At-Large') return Infinity // Place "At-Large" at the end
      return Number.parseInt(value.match(/\d+/), 10) // Extract the numeric part
    }
    if (order === 'asc') {
      data.sort((a, b) => ordinalToNumber(a[orderBy]) - ordinalToNumber(b[orderBy]))
    } else {
      data.sort((a, b) => ordinalToNumber(b[orderBy]) - ordinalToNumber(a[orderBy]))
    }
  } else if (type === 'percentage') {
    data.sort((a, b) => {
      const valueA = getPercentageValueForSort(a[orderBy])
      const valueB = getPercentageValueForSort(b[orderBy])

      if (order === 'asc') {
        return valueA - valueB
      } else {
        return valueB - valueA
      }
    })
  } else {
    data.sort((a, b) => {
      const ageA = Number.parseInt(a.binName) // sorting numeric data
      const ageB = Number.parseInt(b.binName)
      if (order === 'asc') {
        return ageA - ageB
      } else {
        return ageB - ageA
      }
    })
  }
}
